var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useContext } from 'react';
import AutoSizer from 'react-virtualized-auto-sizer';
import { FixedSizeList as List } from 'react-window';
import MapRow from './MapRow';
import MapListFilter from './MapListFilter';
import Fuse from 'fuse.js';
import { AppContext } from '../index';
var MapsListComponent = function (_a) {
    var mapsList = _a.mapsList;
    var _b = __read(React.useState(''), 2), filter = _b[0], setFilter = _b[1];
    var _c = __read(React.useState('none'), 2), sortField = _c[0], setSortField = _c[1];
    var _d = __read(React.useState('desc'), 2), sortDirection = _d[0], setSortDirection = _d[1];
    var t = useContext(AppContext).t;
    // Row renderer for the list
    var fuse = new Fuse(mapsList || [], { keys: ['title'] });
    var filteredMaps = mapsList;
    if (mapsList != null && mapsList.length > 0 && filter != null && filter != "") {
        var results = fuse.search(filter.toLowerCase());
        filteredMaps = results.map(function (result) { return result.item; });
    }
    var sortMaps = function (maps, field, direction) {
        if (field === 'none') {
            return maps;
        }
        return maps.sort(function (a, b) {
            var dateA = new Date(a[field]);
            var dateB = new Date(b[field]);
            if (direction === 'asc') {
                return dateA > dateB ? 1 : -1;
            }
            else {
                return dateA < dateB ? 1 : -1;
            }
        });
    };
    filteredMaps = sortMaps((filteredMaps || []).slice(), sortField, sortDirection);
    var Row = function (_a) {
        var index = _a.index, style = _a.style;
        return (React.createElement("div", { style: style, className: 'mapRow' + (index % 2 ? ' alternate' : '') },
            React.createElement(MapRow, { map: filteredMaps[index] })));
    };
    var handleFilterChange = function (e) {
        setFilter(e.target.value); // Update the filter state with the input value
    };
    var handleSortChange = function (field) {
        if (sortField === field) {
            //should go asc/desc/ field none
            if (sortDirection === 'desc') {
                setSortDirection('asc');
            }
            else if (sortDirection === 'asc') {
                setSortDirection('desc');
                setSortField('none');
            }
        }
        else {
            setSortField(field);
            setSortDirection('desc'); // Default to descending when switching columns
        }
    };
    return (React.createElement("div", { style: { position: 'absolute', top: '35px', bottom: 0, width: '100%' }, className: 'map-list-wrapper' },
        React.createElement(MapListFilter, { filter: filter, onFilterChange: handleFilterChange, sortField: sortField, sortDirection: sortDirection, onSortChange: handleSortChange }),
        React.createElement("div", { style: { position: 'absolute', top: '34px', bottom: 0, width: '100%' }, className: 'map-list' },
            (filteredMaps != null && filteredMaps.length != 0) && (React.createElement(AutoSizer, null, function (_a) {
                var height = _a.height, width = _a.width;
                return (React.createElement(List, { height: height, itemCount: filteredMaps.length, itemSize: 90, width: width }, Row));
            })),
            mapsList != null && mapsList.length == 0 && (React.createElement("div", { className: 'noMapsFounds' },
                React.createElement("div", { className: 'msg' }, t('map_list.no_maps')))),
            mapsList != null && mapsList.length > 0 && filteredMaps.length == 0 && (React.createElement("div", { className: 'noMapsFounds' },
                React.createElement("div", { className: 'msg' }, t('map_list.no_maps'))))),
        mapsList == null && (React.createElement("div", { className: 'listLoader' }))));
};
export default MapsListComponent;
